import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'table-multiselect',
  templateUrl: './table-multiselect.component.html',
  styleUrls: ['./table-multiselect.component.scss'],
})
export class TableMultiselectComponent implements OnInit {
  @Input() rows;
  @Input() tableHeaders;
  @Input() isCheckbox;
  @Output() sendRowData = new EventEmitter<any>();

  checked = false;
  indeterminate = false;
  listOfCurrentPageData: any[] = [];
  setOfCheckedId = new Set();
  arrayData: any[] = [];

  constructor() {}

  ngOnInit(): void {}

  onCurrentPageDataChange(e): void {
    this.listOfCurrentPageData = e;
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    const listOfEnabledData = this.listOfCurrentPageData.filter(
      ({ disabled }) => !disabled
    );

    this.checked = listOfEnabledData.every((item) => {
      this.setOfCheckedId.has(item.id);
    });
    this.indeterminate =
      listOfEnabledData.some((item) => this.setOfCheckedId.has(item.id)) &&
      !this.checked;
  }

  unsorted() {}

  onItemChecked(index, e, data) {
    this.updateCheckedSet(index, e, data);
    this.refreshCheckedStatus();
  }

  updateCheckedSet(id: number, checked: boolean, data) {
    // this.arrayData = [];
    // this.setOfCheckedId.clear();
    if (checked) {
      this.setOfCheckedId.add(id);
      this.arrayData.push(data);
    } else {
      this.setOfCheckedId.delete(id);
      this.arrayData.splice(id, 1);
    }
    // console.log('Data para trabajar', this.arrayData);
  }

  isObject(obj) {
    return typeof obj === 'object';
  }

  selectedRow(data) {
    this.sendRowData.emit(data);
  }
}
